import type { PropertyInput, PropertyInputFilter } from './types'

export function getPropertyId(input: PropertyInput): string | undefined {
  if (input.type === 'directHub') {
    return undefined
  }
  return input.propertyId
}

export function getEntityId(input: PropertyInput): string | undefined {
  if (input.type === 'directField') {
    return input.entityId
  }
  return undefined
}

export function getFilters(input: PropertyInput): PropertyInputFilter | undefined {
  if (input.type === 'related') {
    return input.filters
  } else if (input.type === 'viaReference') {
    return input.filters
  }
  return undefined
}

export function getViaPropertyId(input: PropertyInput): string | undefined {
  if (input.type === 'viaReference') {
    return input.viaPropertyId
  }
  return undefined
}
